import { IAsset, AssetProvider } from "@imcc/transport";
import { ContentDisposition } from "@lib/network/content-disposition";
import { FilePath } from "@lib/files/file-path";

export async function urlToAsset(url: string): Promise<IAsset> {
  return fetch(url).then((response) => {
    const dispositionString = response.headers.get("content-disposition") as string;
    const disposition = new ContentDisposition(dispositionString);

    return {
      id: FilePath.baseName(disposition.filename),
      name: FilePath.fileName(disposition.filename),
      fileExtension: FilePath.fileExtension(disposition.filename),
      downloadUrl: url,
      thumbnailUrl: url,
      provider: AssetProvider.External,
      assetType: "other",
      relevanceScore: 0,
      downloads: []
    };
  });
}
